define('components/factory/views/VideoView', [
    'components/factory/templates/videoview',
    'components/videofactory/VideoFactory',
    'components/trackingbridge/TrackingBridge'
], function(tpl, VideoFactory, TrackingBridge) {

    var VideoView = Mazarine.View.extend({

        events: {},

        template: tpl,

        className: "maz-video-view",

        videoModel: null,
        videoView: null,

        currentCompletion: null,

        afterRender: function() {

            this.currentCompletion = null;
            var videoFromJSON = this.model.get('video');
            var videoType = videoFromJSON.type;
            var videoId = videoFromJSON.videoId;

            this.playOnStart = true;
            var obj = _.extend({ //TODO cleaner les callback (faire des fonctions au lieu de binder à la volée)
                "viewId": _.uniqueId( "video-" + videoId ),
                "onReady": _.bind( this.onPlayerReady, this),
                "isMobile": this.model.get('isMobile'),
                "isIphone": this.model.get('isIphone'),
                "domId": _.uniqueId(videoFromJSON.videoId),
                "onPlay": _.bind( function(){
                    _.delay(function(_this){_this.$('.maz-videoproduct-video-steps').removeClass('maz-paused');}, 2000, this);

                    if (this.playOnStart) {
                        TrackingBridge.trackEvent('videoplay', {"{{videotype}}": videoFromJSON.type.toUpperCase(), "{{videoid}}": videoFromJSON.videoId});
                        this.playOnStart = false;
                    }

                    var callback = this.model.get('onPlay');
                    if( callback ) callback( this );

                    var multimediasCallback = this.model.get('onPlayMultimediasVideo');
                    if( multimediasCallback ) multimediasCallback( this );
                }, this),
                "onPause": _.bind( function(){ this.$('.maz-videoproduct-video-steps').addClass('maz-paused'); var callback = this.model.get('onPause'); if( callback ) callback(); }, this),
                "onEnded": _.bind( function(){
                    this.$('.maz-videoproduct-video-steps').addClass('maz-paused');
                    var callback = this.model.get('onEnded');
                    if( callback ) callback( this );

                    _.delay(function(_this){_this.playOnStart = true;}, 10, this);
                }, this),
                "onFullscreenChange": _.bind( function( e, isFullscreen ){

                    if( isFullscreen ){
                        TrackingBridge.trackEvent('videofullscreen', {"{{videotype}}": videoFromJSON.type.toUpperCase(), "{{videoid}}": videoFromJSON.videoId});
                    } else {
                        TrackingBridge.trackEvent('videoexitfullscreen', {"{{videotype}}": videoFromJSON.type.toUpperCase(), "{{videoid}}": videoFromJSON.videoId});
                    }

                    var callback = this.model.get('onFullscreenChange'); if( callback ) callback( e, isFullscreen );
                }, this)
            }, videoFromJSON);

            this.videoModel = VideoFactory.createModelFromData(obj);
            this.videoView = VideoFactory.createViewFromModel( this.videoModel );

            this.listenTo( this.videoModel, "change:currentTime", this.onCurrentTimeChange);

            this.$('.maz-video-wrapper').eq(0).prepend( this.videoView.render().$el );
            this.videoView.afterRender();
        },

        onRemove: function() {
            this.destroy();
        },

        destroy: function() {
            this.stopListening( this.videoModel );
            if( this.videoView ){
                this.videoView.destroy();
            }
        },

        /*
         * Interface Video
         */
        play: function() {
            if( this.videoView ){
                this.videoView.play();
            }
        },

        pause: function() {
            if( this.videoView ){
                this.videoView.pause();
            }
        },

        stop: function() {
            if( this.videoView ){
                this.videoView.stop();
            }

            //
            _.delay(function(_this){_this.playOnStart = true;}, 10, this);
        },

        toggleFullScreen: function() {
            if( this.videoView ){
                this.videoView.toggleFullScreen();
            }
        },

        mute: function() {
            if( this.videoView ){
                this.videoView.mute();
            }
        },

        unMute: function() {
            if( this.videoView ){
                this.videoView.unMute();
            }
        },

        onPlayerReady: function() {
            var callback = this.model.get('onReady');
            if( callback )
                callback();
            this.model.set("isReady", true);
        },

        /*
         * Gestion Timecodes
         */
        onCurrentTimeChange: function( model, time ) {

            var videoFromJSON = this.model.get('video');
            var onProgressCallback = this.model.get('onProgress');
            var duration = this.videoView.getDuration();

            if( onProgressCallback ) {
                onProgressCallback( time, duration );
            }

            var completion = duration > 0 ? Math.round( (time / duration * 100) + 1 ) : 0;

            if (completion >= 25 && completion < 50) {
                completion = 25;
            } else if (completion >= 50 && completion < 75) {
                completion = 50;
            } else if (completion >= 75 && completion < 100) {
                completion = 75;
            }

            if( completion !== this.currentCompletion && completion >= 25 & completion <= 100 ) {
                this.currentCompletion = completion;
                TrackingBridge.trackEvent('videocompletion', {"{{videotype}}": videoFromJSON.type.toUpperCase(), "{{videoid}}": videoFromJSON.videoId, "{{completion}}": this.currentCompletion});
            }

        }
    });

    return VideoView;
});
